import React, { createContext, useContext, useState, } from 'react';
const ActiveSubmenuContext = createContext({
    activeSubmenu: null,
    setActiveSubmenu: () => { },
});
export const useActiveSubmenu = () => {
    return useContext(ActiveSubmenuContext);
};
export const ActiveSubmenuContextProvider = ({ children, }) => {
    const [activeDropdown, setActiveDropdown] = useState(null);
    return (React.createElement(ActiveSubmenuContext.Provider, { value: {
            activeSubmenu: activeDropdown,
            setActiveSubmenu: setActiveDropdown,
        } }, children));
};
//# sourceMappingURL=ActiveSubmenuProvider.js.map